import React from "react";
import OrderTaskForm from "./OrderTaskForm";

// Tarea «Preparar pedido» (actor PICKING) — FORMCODE ELPREP
const CONFIG = {
  stage: 0,
  title: "Preparar pedido",
  intro: "Reúne los productos del pedido y déjalo listo para entregar.",
  sections: ["pedido", "productos", "montos", "cliente", "entrega", "facturacion"],
  checklist: [
    "Revisa el pedido y el tipo de envío (retiro en tienda o domicilio).",
    "Junta y empaca los productos.",
    "Si falta stock o algo no cuadra, márcalo como observado.",
  ],
  optionHints: {
    "Pedido listo": "Pasa a Entrega: tienda o domicilio, según el tipo de envío del pedido.",
    "Falta stock / observado": "Se va a Resolver observación; el pedido no avanza hasta resolverlo.",
  },
};

export default function ElevaxPrepararPedido(props) {
  return <OrderTaskForm {...props} config={CONFIG} />;
}
